import Box from '@mui/material/Box';
import { DataGrid, GridCallbackDetails, GridCellParams, GridColDef, GridEventListener, GridRowSelectionModel, GridValueGetterParams, gridExpandedSortedRowEntriesSelector, gridPaginatedVisibleSortedGridRowIdsSelector, gridRowsLookupSelector, useGridApiEventHandler } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import { useEffect, useLayoutEffect, useState } from 'react';
import { GridApi } from '@mui/x-data-grid';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDebouncedCallback } from 'use-debounce';

interface RecommendationListTableProps {
    recomendations?: any
    loading?: boolean
    onItemClick?: Function
    selectedRowId?: number
}

const columns: GridColDef[] = [
    {
        field: 'date',
        headerName: 'Date',
        width: 140,

        valueGetter: (value, row, column, apiRef) => {
            return DateTime.fromISO(row?.date).toFormat('M/dd/yyyy');
        }
    },
    {
        field: 'recommendation',
        headerName: 'Recommendation',
        width: 260,
        valueGetter: (value: any, row, column, apiRef) => {
            return value?.text;
        },
        cellClassName: (params: GridCellParams<any>) => {
     
            if (params?.row?.recommendation.priceDirection === 0) {
                return 'MuiDataGrid-cell--status-ok';
            }

            if (params?.row?.recommendation?.text !== undefined) {
                return 'MuiDataGrid-cell--highlighted';
            }

            return '';        
        }
    },
    {
        field: 'medianPrice',
        headerName: 'Median price',
        width: 150,
        valueGetter: (value, row, column, apiRef) => {
            return `$${Math.round(row.monitorLaunchTask.medianPrice)}`
        }
    },

]

export const RecommendationListTable = (props: RecommendationListTableProps): JSX.Element => {
    const {
        recomendations,
        loading,
        onItemClick,
        selectedRowId
    } = props;

    const apiRef = useGridApiRef();


    const [paintFinished, setPaintFinished] = useState(false)

    const handleRowClick = (event: any) => {
        onItemClick?.(event.row)
    }

    useEffect(() => {
        if (apiRef === undefined) {
            return;
        }

        if (apiRef.current === undefined) {
            return;
        }

        if (selectedRowId === undefined) {
            return;
        }

        if (paintFinished === false) {
            return;
        }


        apiRef.current.scrollToIndexes({
            rowIndex: apiRef.current.getRowIndexRelativeToVisibleRows(selectedRowId),
            colIndex: 0,
            
        });

    }, [selectedRowId, paintFinished])

    const debounced = useDebouncedCallback(
        // function
        () => {
            setPaintFinished(true)
        },
        // delay in ms
        200
    );

    useEffect(() => {
        if (apiRef === undefined) {
            return;
        }

        if (apiRef.current === undefined) {
            return;
        }

    }, [apiRef])

    const handleGetRowClassName = (params: any): string => {
        debounced()

        if (params.id === selectedRowId) {
            return `MuiDataGrid-row--selected`;
        }

        return ``;
    }

    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

    return (
        <>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                <DataGrid
                    apiRef={apiRef}
                    onRowClick={handleRowClick}
                    sx={{
                        height: loading ? '180px' : 'auto',
                        '& .MuiDataGrid-columnHeaderTitle': {
                            whiteSpace: "normal",
                            lineHeight: "normal",
                            fontSize: {
                                xs: '20px',
           
                            },
                            fontWeight: '600'
                        },
                        '& .MuiDataGrid-cellContent': {
                            fontSize: {
                                xs: '20px',

                            }
                        },
                        '& .MuiDataGrid-cell': {
                            fontSize: {
                                xs: '20px',

                            }
                        },
                        "& .MuiDataGrid-columnHeader": {
                            // Forced to use important since overriding inline styles
                            height: "unset !important"
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            // Forced to use important since overriding inline styles
                            maxHeight: "168px !important"
                        },
                        minHeight: 180,
                        maxHeight: 400,
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer'
                        },
                        '& .MuiDataGrid-row--selected': {
                            backgroundColor: `#aecdeb`

                        },
                        '& .MuiDataGrid-cell--highlighted': {
                            color: `#ef5350`
                        },
                        '& .MuiDataGrid-cell--status-ok': {
                            color: `#4caf50`
                        },
                    }}
                    getRowClassName={handleGetRowClassName}
                    rows={recomendations || []}
                    columns={columns}
                    disableRowSelectionOnClick             
                />
            </Box>
        </>
    )
}